import type { OrderFulfillmentType } from "@sellar-io/api-v2/types";

export const getConfirmationFulfillmentOptionValue = (
  fulfillmentType: OrderFulfillmentType | "sellar-shipping",
) => {
  if (
    ["dxBasic", "ups", "courier", "dx", "dxDropOff", "apc"].includes(
      fulfillmentType,
    )
  ) {
    return "sellar-shipping";
  }

  return fulfillmentType;
};
